import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import './styles.scss'

import moreInfo from './assets/more_info.svg'
import connector from 'src/decorators/connector'
import { IStoresMap } from 'src/types'

import ComplectItem from "./complect_item"
import ReactToPrint from 'react-to-print';
import { isMobile } from 'react-device-detect';


class Busket extends Component<ReturnType<typeof storesToProps>> {
  //   constructor(props: any) {
  //     super(props);
  //     this.componentRef = (element: any) => {
  //       this.componentRef = element;
  //   };
  // }
  public state = { isOpen: false, isOpenEntr: false }
  //public componentRef: React.RefObject<HTMLInputElement>;



  public onOpenEntrHundler = (e: any) => {
    e.stopPropagation()
    this.setState({ isOpenEntr: !this.state.isOpen })
  }

  public onChangeIsOpenHundler = (val: boolean) => {
    this.setState({ isOpen: val })
  }

  public onOpenModal = () => {
    const modal_email = document.querySelector('#modal_email') as any;
    if (modal_email) {
      modal_email.style.display = 'block';
      document.body.style.overflow = 'hidden';
    }
  }

  public render() {
    const {
      getProdictsCount,
      allPrice,
      getGoods,
      removeProduct,
      getNearHousePlateGoods,
      getParkingPlateGoods,
      entrsPlates,
      removeEntrPlates,
      removeAll,
      getParkingPlateGoodsPrice,
      getNearHousePlateGoodsPrice
    } = this.props.busket
    const { housePlates } = this.props.configuratorStore
    const { getCountsOfFlats, activeEntrance, fullPrice } = housePlates
    let result = new Date();
    result.setDate(result.getDate() + 5);

    return (
      <div className="backet_container">
        {
          !isMobile ?
            <div className="show_all" onMouseEnter={() => this.onChangeIsOpenHundler(true)}>
              <div className="img_busket_cont">{getProdictsCount}</div>
              <div className="price">{allPrice} руб.</div>
            </div>
            : <a className="show_all" href={"/personal/cart/"}>
              <div className="img_busket_cont">{getProdictsCount}</div>
              <div className="price">{allPrice} руб.</div>
            </a>
        }


        <div className={`opened_busket ${this.state.isOpen ? "open" : "close"}`}>
          <div className="background" onClick={() => this.onChangeIsOpenHundler(false)} />
          <div className="busket" onMouseLeave={() => this.onChangeIsOpenHundler(false)}>
            <div className="basket-line" >
              <a className="basket-line-mini">
                <div className="basket-line-mini__b">
                  <div className="basket-line-mini__icon">
                    <svg viewBox="0 0 25.1 29.4" width="25.1" height="29.4">
                      <path v-if="options.arResult.NUM_PRODUCTS > 0" fill="#ff8d00" d="M2 6.9h21.1l1 21.5H1z" />
                      <path fill="none" stroke="currentColor" strokeMiterlimit="22.93" strokeWidth="2" d="M2 6.9h21.1l1 21.5H1z" />
                      <path fill="none" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="22.93" strokeWidth="2" d="M17 9.5v-5C16.9 2.4 15.1.9 13 1h-1C9.9.9 8.1 2.5 8 4.6v5" />
                    </svg>
                  </div>
                  <div className="basket-line-mini__count"></div>
                </div>
                <div className="basket-line-mini__sum" v-html="options.arResult.TOTAL_PRICE" />
              </a>

              {/* <transition name="basket-over"> */}
              <div className="basket-line-body" id="basket-line-body" ref="basket-line-body" v-show="isVisible">
                <div className="basket-line-body__inset">
                  <div className="basket-line-body__title">Корзина</div>

                  <div className="basket-line-body__items">
                    <div className="scroll-area">
                      <div className="basket-line-body__items-wrapper">

                        {entrsPlates.length > 0 && <div className="complect">
                          <div className={`complect__group${this.state.isOpenEntr ? '__active' : ""}`} onClick={this.onOpenEntrHundler}>
                            <div className="complect__group__name">
                              <span>Комплект внутриподъездных табличек на дом</span>
                              <div className="complect__close" onClick={removeAll}>
                                <img src="/local/templates/sign_plus/images/close.svg" />
                              </div>
                            </div>

                            {this.props.configuratorStore.housePlates.Entrances.map((item, index) =>
                              <ComplectItem key={index} entrNumber={index} entrPrice={item.priceEntrance} />)}
                            <div className="complect__group__summ">
                              <span>{housePlates.fullPrice} руб.</span>
                            </div>
                          </div>
                        </div>}
                        {getNearHousePlateGoods.length > 0 && <div className="complect">
                          <div className={`complect__group${this.state.isOpenEntr ? '__active' : ""}`} onClick={this.onOpenEntrHundler}>
                            <div className="complect__group__name">
                              <span>Комплект для придомовой территории</span>
                              <div className="complect__close" onClick={removeAll}>
                                <img src="/local/templates/sign_plus/images/close.svg" />
                              </div>
                            </div>
                            {getNearHousePlateGoods.map(item =>
                              <div className="custom_items_div" id={item.id}>
                                <ul className="complect__items">
                                  <li className="complect__item">
                                    <div className="complect__item__dopinfo">
                                      <div className="complect__item__img">
                                        <img className="image" src={item.img as string} />
                                        <span>{item.size}.</span>
                                      </div>
                                      <div className="complect__item__dopinfo">
                                        <div className="complect__item__name">{item.name}</div>
                                        <div className="complect__item__val">{item.description}</div>
                                      </div>
                                      <div className="complect__item__close">
                                        <img src="/local/templates/sign_plus/images/close.svg" onClick={() => removeProduct(item.randId)} />
                                      </div>
                                    </div>
                                    <div className="complect__item__summdiv">
                                      <div className="complect__item__price">{item.price} руб/шт</div>
                                      <div className="complect__item__quant">{item.count} шт</div>
                                      <div className="complect__item__summ">{item.count * item.price} руб.</div>
                                    </div>
                                  </li>
                                </ul>
                              </div>)
                            }
                            <div className="complect__group__summ">
                              <span>{getNearHousePlateGoodsPrice} руб.</span>
                            </div>
                          </div>
                        </div>}
                        {getParkingPlateGoods.length > 0 && <div className="complect">
                          <div className={`complect__group${this.state.isOpenEntr ? '__active' : ""}`} onClick={this.onOpenEntrHundler}>
                            <div className="complect__group__name">
                              <span>Комплект для парковки</span>
                              <div className="complect__close" onClick={removeAll}>
                                <img src="/local/templates/sign_plus/images/close.svg" />
                              </div>
                            </div>
                            {getParkingPlateGoods.map(item =>
                              <div className="custom_items_div" id={item.id}>
                                <ul className="complect__items">
                                  <li className="complect__item">
                                    <div className="complect__item__dopinfo">
                                      <div className="complect__item__img">
                                        <img className="image" src={item.img as string} />
                                        <span>{item.size}.</span>
                                      </div>
                                      <div className="complect__item__dopinfo">
                                        <div className="complect__item__name">{item.name}</div>
                                        <div className="complect__item__val">{item.description}</div>
                                      </div>
                                      <div className="complect__item__close">
                                        <img src="/local/templates/sign_plus/images/close.svg" onClick={() => removeProduct(item.randId)} />
                                      </div>
                                    </div>
                                    <div className="complect__item__summdiv">
                                      <div className="complect__item__price">{item.price} руб/шт</div>
                                      <div className="complect__item__quant">{item.count} шт</div>
                                      <div className="complect__item__summ">{item.count * item.price} руб.</div>
                                    </div>
                                  </li>
                                </ul>
                              </div>)
                            }
                            <div className="complect__group__summ">
                              <span>{getParkingPlateGoodsPrice} руб.</span>
                            </div>
                          </div>
                        </div>}
                        {getGoods.map(item =>
                          <div className="custom_items_div" id={item.id}>
                            <ul className="complect__items">
                              <li className="complect__item">
                                <div className="complect__item__dopinfo">
                                  <div className="complect__item__img">
                                    <img className="image" src={item.img as string} />
                                    <span>{item.size}.</span>
                                  </div>
                                  <div className="complect__item__dopinfo">
                                    <div className="complect__item__name">{item.name}</div>
                                    <div className="complect__item__val">{item.description}</div>
                                  </div>
                                  <div className="complect__item__close">
                                    <img src="/local/templates/sign_plus/images/close.svg" onClick={() => removeProduct(item.randId)} />
                                  </div>
                                </div>
                                <div className="complect__item__summdiv">
                                  <div className="complect__item__price">{item.price} руб/шт</div>
                                  <div className="complect__item__quant">{item.count} шт</div>
                                  <div className="complect__item__summ">{item.count * item.price} руб.</div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="basket-line-body__footer">
                    <div className="basket-line-body__footer-list">
                      <dl className="basket-line-body__footer-item basket-line-body__footer-item--quantity">
                        <dt>Всего наименований</dt>
                        <dd>{getGoods.length}</dd>
                      </dl>
                      <dl className="basket-line-body__footer-item basket-line-body__footer-item--done-date">
                        <dt>Готовность</dt>

                        <dd v-if="!priceUpdateLoading">{result.toLocaleDateString('ru')}</dd>
                      </dl>
                      <dl className="basket-line-body__footer-item basket-line-body__footer-item--total">
                        <dt>Итого</dt>
                        <dd v-if="!priceUpdateLoading">{allPrice} руб</dd>
                      </dl>
                    </div>
                    <div className="basket-line-body__controls">
                      <a className="button button--primary" href={"/personal/cart/"}>Перейти в корзину</a>
                    </div>
                    <div className="basket-line-body__controls2">
                      <a v-tooltip="'Печать'" href={'javascript:(print());'}>
                        <svg viewBox="0 0 29.2 24.4" width="29.2" height="24.4"><path fill="none" stroke="#222a32" stroke-linejoin="round" d="M3.2 5.7L4.7.5h19.8l1.4 5.2M4.6 14.9h19.9l1.5 9H3.1z"></path><path fill="none" stroke="#222a32" stroke-linecap="round" stroke-miterlimit="22.93" d="M23.1 9.3h2.8"></path><path fill="none" stroke="#222a32" stroke-linejoin="round" d="M.5 5.6v13.8h3.3l.8-4.5h19.9l.8 4.5h3.4V5.6z"></path><path fill="none" stroke="#222a32" stroke-linecap="round" stroke-miterlimit="22.93" d="M8 21h13.5"></path>
                        </svg>
                        {/* <ReactToPrint
                                  trigger={() => {
                                    // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                                    // to the root node of the returned component as it will be overwritten.
                                    return <a href="#">Print this out!</a>;
                                  }}
                                  content={() => this.componentRef}
                                />
                                <div ref={el => (this.componentRef = el)} /> */}
                      </a>
                      <span className="basket-line-body__controls2-spliter"></span>
                      <a className="modal-trigger-email" onClick={this.onOpenModal} v-tooltip="'Отправить список'">
                        <svg viewBox="0 0 31.1 21" width="31.1" height="21"><g fill="none" stroke="#222a32"><path stroke-miterlimit="22.93" d="M1.9.5h27.4c.8 0 1.4.6 1.4 1.4v17.3c0 .8-.6 1.4-1.4 1.4H1.9c-.8 0-1.4-.6-1.4-1.4V1.9c0-.8.6-1.4 1.4-1.4z"></path><path stroke-linejoin="round" d="M19.2 10.2l10.9 9.1m-29 0L12 10.2M1.1.8l11.4 9.6c2.8 2.4 3.3 2.4 6.2 0L30.1.8"></path></g>
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div >
          </div >
        </div >

      </div>
    )


  }
}


const storesToProps = ({ store }: IStoresMap) => ({
  busket: store.BusketStore,
  configuratorStore: store.configuratorStore,
})

export default connector(storesToProps)(Busket)